// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33JI0","comment":"styles_comment__2GgB7"};